import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import { createGenerateClassName, StylesProvider, ThemeProvider } from '@material-ui/core';
import merge from 'lodash/merge';
import React, { memo, useMemo } from 'react';
import oriTheme from '../theme';
export const OriMuiThemeProvider = (_ref) => {
  let children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      disableInjectFirst = _ref.disableInjectFirst,
      disableStylesProvider = _ref.disableStylesProvider,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "theme", "disableInjectFirst", "disableStylesProvider"]);

  const internalTheme = useMemo(() => {
    if (typeof theme === 'function') {
      return theme(oriTheme);
    }

    return merge(oriTheme, theme);
  }, [theme]);
  const classNameGenerator = useMemo(() => {
    if (Object.keys(rest).length > 0) {
      return createGenerateClassName(rest);
    }

    return undefined;
  }, [rest]);

  if (disableStylesProvider) {
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: internalTheme
    }, children);
  }

  return /*#__PURE__*/React.createElement(StylesProvider, {
    injectFirst: !disableInjectFirst,
    generateClassName: classNameGenerator
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: internalTheme
  }, children));
};
OriMuiThemeProvider.displayName = 'OriMuiThemeProvider';
export default /*#__PURE__*/memo(OriMuiThemeProvider);